import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { CustomerExecutionModal } from "./CustomerExecutionModal/CustomerExecutionModal";

export const CustomerExecutionBtn = observer(() => {
  const { actionModals, user, bidCard } = useStores();

  function openModalHandler() {
    actionModals.open(() => <CustomerExecutionModal />, {
      title: "Согласие на исполнение заявки",
      width: "700px",
    });
  }
  return (
    <CustomButton
      onClick={openModalHandler}
      tooltip="Инициировать перевод криптовалюты в адрес иностранного контрагента"
    >
      Отправить ЦВ
    </CustomButton>
  );
});
